import { Component } from 'react';
import logger from '../utils/logger';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props); 
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        // Enviar error a CloudWatch
        logger.reactError(error, info);
    }

    render() {
        if (this.state.hasError) {
            const errorMessage = this.state.error?.message || this.state.error?.toString() || 'Error desconocido';
            return <>
                <h1>Ocurrió un error inesperado. Por favor, revisa la consola.</h1>
                <code>
                    {errorMessage}
                </code>
            </>;
        }

        return this.props.children;
    }
}


export default ErrorBoundary;